export default __webpack_public_path__ + "static/media/ic-heart.1ea4639c.svg";